// extracted by mini-css-extract-plugin
export default {"statsPageDiv":"StatsPage_statsPageDiv__yps0N","viewSelect":"StatsPage_viewSelect__+zuQ5"};